import * as React from 'react';
import styled from 'styled-components';
import { Input } from '../../../../components';
import { InputProps } from '../../../../components/Form/Input';
import { media } from '../../../../config/theme/utils';
import { HIDDEN } from '../../constants';
import { InputFieldWidth } from '../../types';

type Props = {
  width: InputFieldWidth;
} & InputProps;

const OnBoardingInput: React.FunctionComponent<Props> = ({ width, ...props }: Props) => (
  <OnBoardingInputWrapper error={props.error} type={props.type} flexWidth={width}>
    <Input errorAsBlock={false} {...props} />
  </OnBoardingInputWrapper>
);

export const OnBoardingInputWrapper = styled.div<{ flexWidth: InputFieldWidth; type?: string; error?: string }>`
  flex-basis: ${props => (props.flexWidth.desktop === 12 ? '100%' : 94 / (12 / props.flexWidth.desktop) + '%')};
  position: relative;
  margin-bottom: 5px;
  visibility: ${props => (props.type === HIDDEN ? 'hidden' : 'visible')};

  ${props => media.tablet`
    flex-basis: ${
      props.flexWidth.desktop === 12 ? '100%' : 94 / (12 / (props.flexWidth.tablet || props.flexWidth.desktop)) + '%'
    };
  `}

  > div > input {
    ${props => media.mobile`
      background: ${props.theme.onboarding.input.background}
    `};
    }
    
  }

  label {
    text-align: left;
    display: block;
  }

  .country-select {
    > div {
      ${props => media.mobile`
      background: ${props.theme.onboarding.input.background}
    `}
    }
    margin: 8px 0 25px;
  }
`;

export default OnBoardingInput;
